//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/assets/menuIconfont/iconfont.css'
export default {
  name: 'IconSelect',
  data() {
    return {
      name: '',
      iconList: [],
      icons: [
        { icon: 'icon-butieleixing', text: '补贴类型' },
        { icon: 'icon-tongji_niandu', text: '统计年度' },
        { icon: 'icon-jizhu', text: '保险理赔用户查询' },
        { icon: 'icon-daikuanchanpinguanli', text: '贷款产品管理' },
        { icon: 'icon-baoxianyixiang', text: '保险意向' },
        { icon: 'icon-jinrongjigouguanli', text: '金融机构管理' },
        { icon: 'icon-jinrongchanpinchaxun', text: '金融产品查询' },
        { icon: 'icon-daikuanyixiangchaxun', text: '贷款意向查询' },
        {
          icon: 'icon-baoxianchanpinchaxun-yunying',
          text: '保险产品查询-运营',
        },
        { icon: 'icon-toubaoyixiangchaxun-yunying', text: '投保意向查询-运营' },
        { icon: 'icon-shuzinongjihezuoshe', text: '数字农机合作社' },
        { icon: 'icon-nongjihezuoshefenbu', text: '农机合作社分布' },
        { icon: 'icon-nongjihezuosheguanli', text: '农机合作社管理' },
        { icon: 'icon-hezuoshetongji', text: '合作社统计' },
        {
          icon: 'icon-gouzhiyuyingyongbutieliucheng',
          text: '购置补贴应用流程',
        },
        { icon: 'icon-gouzhibutiejijujianguan', text: '购置补贴机具监管' },
        { icon: 'icon-yingyongbutiejijujianguan', text: '应用补贴机具监管' },
        {
          icon: 'icon-shehuihuacaidan_nongjizuoyeshenhe',
          text: '农机作业审核',
        },
        { icon: 'icon-shehuihuacaidan_fuwumubiaoguanli', text: '服务目标管理' },
        { icon: 'icon-shehuihuacaidan_zuoyebutieguanli', text: '作业补贴管理' },
        { icon: 'icon-shehuihuacaidan_butiezijinguanli', text: '补贴资金管理' },
        { icon: 'icon-shehuihuacaidan_heimingdanguanli', text: '黑名单管理' },
        {
          icon: 'icon-shehuihuacaidan_zhengcewenjianguanli',
          text: '政策文件管理',
        },
        {
          icon: 'icon-shehuihuacaidan_shehuihuafuwutongji',
          text: '社会化服务统计',
        },
        { icon: 'icon-zhihuiguoyuan', text: '智慧果园' },
        { icon: 'icon-zhihuidapeng', text: '智慧大棚' },
        { icon: 'icon-zhihuinongchang', text: '智慧农场' },
        { icon: 'icon-dingdan', text: '订单' },
        { icon: 'icon-shangpinguanli', text: '商品管理' },
        { icon: 'icon-cunjiti', text: '村集体' },
        { icon: 'icon-shezhi', text: '设置' },
        { icon: 'icon-ziyuanchaxun', text: '资源查询' },
        { icon: 'icon-gongyingshangguanli', text: '供应商管理' },
        { icon: 'icon-pinpaiguanli', text: '品牌管理' },
        { icon: 'icon-xitongguanli', text: '系统管理' },
        { icon: 'icon-zuzhiminglu', text: '组织名录' },
        { icon: 'icon-yonghushouquan', text: '用户授权' },
        { icon: 'icon-tuoguanrenwu', text: '托管任务' },
        { icon: 'icon-zuoyejindu', text: '作业进度' },
        { icon: 'icon-hetongguanli', text: '合同管理' },
        { icon: 'icon-shehuihuafuwu', text: '社会化服务' },
        { icon: 'icon-xinwendongtai', text: '新闻动态' },
        { icon: 'icon-tongzhigonggao', text: '通知公告' },
        { icon: 'liuzhuanyewu', text: '流转业务' },
        { icon: 'icon-gouwuche', text: '购物车' },
        { icon: 'icon-hetong', text: '合同管理' },
        { icon: 'icon-yonggongguanli', text: '用工管理' },
        { icon: 'icon-zhineng', text: '智能管理' },
        { icon: 'icon-renyuanguanli', text: '人员管理' },
        { icon: 'icon-suyuan', text: '溯源' },
        { icon: 'icon-nongyeshengchan_caidan', text: '农业生产' },
        { icon: 'icon-ziyuanguanli_caidan', text: '资源管理' },
        { icon: 'icon-huanjingjiance', text: '环境监测' },
        { icon: 'icon-nongjiguanli', text: '农机管理' },
        { icon: 'icon-zuoyeguanli', text: '作业管理' },
        { icon: 'icon-jichuxinxi', text: '基础信息' },
        { icon: 'icon-dingdanguanli', text: '订单管理' },
        { icon: 'icon-AIxuntian', text: 'AI巡田' },
        { icon: 'icon-butieguanli', text: '补贴管理' },
        { icon: 'icon-caiwuguanli', text: '财务管理' },
        { icon: 'icon-daikuandingdan', text: '贷款订单' },
        { icon: 'icon-hezuosheguanli', text: '合作社管理' },
        { icon: 'icon-tuoguan', text: '托管' },
        { icon: 'icon-beidoudingdan', text: '北斗订单' },
        { icon: 'icon-liuzhuan', text: '流转' },
        { icon: 'icon-caidanguanli', text: '菜单管理' },
        { icon: 'icon-zhanghaoguanli', text: '账号管理' },
        { icon: 'icon-jiaoseguanli', text: '角色管理' },
        { icon: 'icon-zidianguanli', text: '字典管理' },
        { icon: 'icon-denglurizhi_caidan', text: '登录日志' },
        { icon: 'icon-caidan_zhiliannongjifenbu', text: '智联农机分布' },
        { icon: 'icon-caidan_zhiliannongjiliebiao', text: '智联农机列表' },
        { icon: 'icon-caidan_zhiliannongjitongji', text: '智联农机统计' },
        { icon: 'icon-caidan_tianjiazhiliannongji', text: '添加智联农机' },
        { icon: 'icon-nongye', text: '农业' },
        { icon: 'icon-dikuaiguanli', text: '地块管理' },
        { icon: 'icon-dikuaiguanli', text: '地块管理' },
        { icon: 'icon-yingjitiaoduyizhangtu', text: '应急调度一张图' },
        { icon: 'icon-chubeiwuzifumaguanli', text: '储备物资赋码管理' },
        { icon: 'icon-zaiqingxinxi', text: '灾情信息' },
        { icon: 'icon-yingjijiuzairenyuan', text: '应急救灾人员' },
        { icon: 'icon-wuzichubeiguanli', text: '物资储备管理' },
        { icon: 'icon-zaiqingchuzhi', text: '灾情处置' },
        { icon: 'icon-yingjijiuzaifuwuzuzhi', text: '应急救灾服务组织' },
        { icon: 'icon-yingjijiuzaiguanlijigou', text: '应急救灾管理机构' },
        { icon: 'icon-yingjijiuzaifuwusheshi', text: '应急救灾服务设施' },
        { icon: 'icon-wuzileibie', text: '应急物资类别管理' },
        { icon: 'icon-icon_cjzhuti', text: '智慧场景' },
        { icon: 'icon-tiaoduguanli', text: '调度管理' },
        { icon: 'icon-gongxuguanli', text: '供需管理' },
        { icon: 'icon-nongjifenbu', text: '农机分布' },
        { icon: 'icon-xinxifabu', text: '信息发布' },
        { icon: 'icon-xinxichaxun', text: '信息查询' },
        { icon: 'icon-sheshifenbu', text: '设施分布' },
        { icon: 'icon-xinxifenbu', text: '信息分布' },
        { icon: 'icon-jigouchaxun', text: '机构查询' },
        { icon: 'icon-chanpinchaxun', text: '产品查询' },
        { icon: 'icon-tiexishenqing', text: '贴息查询' },
        { icon: 'icon-yixiangchaxun', text: '意向查询' },
        { icon: 'icon-qiushouqiuzhong', text: '秋收秋种' },
        { icon: 'icon-nongmin_base_icon', text: '社会化服务统计' },
        { icon: 'icon-nongji_base_icon', text: '农事作业信息管理' },
        { icon: 'icon-jichuxinxi-nongshizuoye', text: '农事作业' },
        { icon: 'icon-zonghenongshifuwuzhongxin', text: '综合农事服务中心' },
        { icon: 'icon-jichuxinxiguanli', text: '基础信息管理' },
        { icon: 'icon-fuwusheshiguanli', text: '服务设施管理' },
        { icon: 'icon-fuwuzhutishenqing', text: '服务主体申请' },
        { icon: 'icon-zuoyeshujutijiao', text: '作业数据提交' },
        { icon: 'icon-baohuxinggengzuo', text: '保护性耕作' },
        { icon: 'icon-tuoguanzuoyechaxun', text: '托管作业查询' },
        { icon: 'icon-tiaoduguanli_1', text: '调度管理_1' },
        { icon: 'icon-yingjiwuzichaxun', text: '应急物资查询' },
        { icon: 'icon-zhichuguanli', text: '支出管理' },
        { icon: 'icon-shouruguanli', text: '收入管理' },
        { icon: 'icon-zuoyebutieshenqing', text: '作业补贴申请' },
        { icon: 'icon-lipeijilu', text: '理赔记录' },
        { icon: 'icon-daikuanjilu', text: '贷款记录' },
        { icon: 'icon-huankuanjilu', text: '还款记录' },
        { icon: 'icon-toubaojilu', text: '投保记录' },
        { icon: 'icon-fenleiguanli', text: '分类管理' },
        { icon: 'icon-zhanghuguanli', text: '账户管理' },
        { icon: 'icon-zhanghuguanli', text: '账户管理' },
        { icon: 'icon-tuoguan-zhengce', text: '托管-政策' },
        { icon: 'icon-jichuxinxi-jixiehuashuai', text: '基础信息-机械化率' },
        { icon: 'icon-tuoguan-zuoyeshujuchaxun', text: '作业数据' },
        { icon: 'icon-ketizijin', text: '课题资金' },
        { icon: 'icon-shiyannongji', text: '试验农机' },
        { icon: 'icon-xiangmuguanli', text: '项目管理' },
        { icon: 'icon-wulianwangshebei', text: '物联网设备' },
        { icon: 'icon-renwushenhe', text: '任务审核' },
        { icon: 'icon-renwuguanli', text: '任务管理' },
        { icon: 'icon-gongzuojilu', text: '工作记录' },
        { icon: 'icon-ketiguanli', text: '课题管理' },
        { icon: 'icon-shengzichanpin', text: '生资产品' },
        { icon: 'icon-shengchanchangshang', text: '生产厂商' },
        { icon: 'icon-xiaoshoumendian', text: '销售门店' },
        { icon: 'icon-shifanshe', text: '示范社' },
        { icon: 'icon-fanhui', text: '返回' },
        { icon: 'icon-zhihuichayuan', text: '智慧茶园' },
        { icon: 'icon-zhihuiyuchang', text: '智慧渔场' },
        { icon: 'icon-zhihuimuchang', text: '智慧牧场' },
        { icon: 'icon-beidouzhinengzhongduan', text: '北斗智能终端' },
        { icon: 'icon-nongyewulianwangshebei', text: '农业物联网设备' },
        { icon: 'icon-zhinengnongjizhuangbei', text: '智能农机装备' },
        { icon: 'icon-jiejuefangan', text: '解决方案' },
        { icon: 'icon-dianshangpingtai', text: '电商平台' },
        { icon: 'icon-jingyingzhuti', text: '经营主体' },
        { icon: 'icon-zuzhiguanli', text: '组织管理' },
        { icon: 'icon-xiangmubiangeng', text: '项目变更' },
        { icon: 'icon-nongjijianding', text: '农机鉴定' },
        { icon: 'icon-dagangguanli', text: '大纲管理' },
        { icon: 'icon-xiangmutiaozheng', text: '项目调整' },
        { icon: 'icon-zhengshuguanli', text: '证书管理' },
        { icon: 'icon-danganguanli', text: '档案管理' },
        { icon: 'icon-yiqishebeiguanli', text: '仪器设备管理' },
        { icon: 'icon-yuanshijiluguanli', text: '原始记录管理' },
        { icon: 'icon-baobiaoguanli', text: '报表管理' },
        { icon: 'icon-nongjitousuguanli', text: '农机投诉管理' },
        { icon: 'icon-yangpinjixiaohaopinguanli', text: '样品及消耗品管理' },
        { icon: 'icon-xitongshezhi', text: '系统设置' },
        { icon: 'icon-qiyeguanli', text: '企业管理' },
        { icon: 'icon-biaozhunguanli', text: '标准管理' },
        { icon: 'icon-leimuguanli', text: '类目管理' },
        { icon: 'icon-jichupeizhi', text: '基础设置' },
        { icon: 'icon-shoucewenjianguanli', text: '手册文件管理' },
        { icon: 'icon-daibanshixiang', text: '待办事项' },
        { icon: 'icon-xiaoshouqiye', text: '销售企业' },
        { icon: 'icon-yujingshezhi', text: '预警设置' },
        { icon: 'icon-fenbu1', text: '分布' },
        { icon: 'icon-fuwuzhongxin', text: '服务中心' },
        { icon: 'icon-fuwuzhan', text: '服务站' },
        { icon: 'icon-fenbu2', text: '分布2' },
        { icon: 'icon-quyugongsi', text: '区域公司' },
      ],
    }
  },
  props: {
    icon: {
      type: String,
      default: () => '',
    },
    iconLoad: {
      type: Number,
      default: () => 0,
    },
  },
  components: {},
  methods: {
    filterIcons() {
      if (this.name) {
        this.iconList = this.icons.filter((item) =>
          item.text.includes(this.name)
        )
      } else {
        this.iconList = this.icons
      }
    },
    selectedIcon(item) {
      this.$emit('selected', item, 1)
      document.body.click()
    },
    reset() {
      this.name = ''
    },
  },
  mounted() {
    this.iconList = JSON.parse(JSON.stringify(this.icons))
  },
  watch: {
    icon(val) {
      if (this.iconLoad == 0 && val) {
        let iconObj = this.icons.find((item) => {
          return item.icon == val
        })
        this.$emit('selected', iconObj, 1)
      }
    },
  },
}
